export const StoreKey = 'messageStore'

export const ScanConfig = {
  'alipay': '使用支付宝扫一扫',
  'weixin': '使用微信扫一扫',
  'yue': '余额支付',
  'integral': '积分兑换'
}

export const PayDuration = 30 * 60 * 1000 // 30分钟

export const IndexPageConfig = Object.freeze({
  phone: '020-8554 4808',
  address: '广州市高新技术开发区香山路3号4层'
})



// WEBPACK FOOTER //
// ./src/utils/config.js